import { format } from 'rut.js';
import { FormatedTutorsResponse, TutorsResponse } from '../types';
import { useTexts } from './useTexts';

export function useColumns(
  data: TutorsResponse['studentPlansAndTutors']['studyPlans'],
): FormatedTutorsResponse {
  const texts = useTexts();

  return {
    studyPlans: data.map((plan) => {
      return {
        name: <p>{plan.name}</p>,
        studyPlanEnrollmentId: plan.studyPlanEnrollmentId,
        tutor: plan.tutor ? (
          <>
            <p>{plan.tutor.names}</p>
            <p>{format(plan.tutor.identification, { dots: true })}</p>
          </>
        ) : (
          <b>{texts.notAssigned}</b>
        ),
        tutorEmail: plan.tutor ? (
          <p>{plan.tutor.email}</p>
        ) : (
          <b>{texts.notAssigned}</b>
        ),
      };
    }),
  };
}
